import React from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import styles from './styles.scss';

const OverlayHandle = function OverlayHandle(props) {
    const {
        target, children, style, className,
    } = props;

    if (target && children) {
        // there should only be one child. If there are more just ignore
        // we can do an isArray check if needed.
        const child = children[0] ?? children;
        const inner = React.cloneElement(child, { className: `${child.props.className} ${styles['overlay-image']}` });

        const overlay = (
            <div className={`${className} ${styles['overlay-container']}`} style={style}>
                {inner}
            </div>
        );
        return createPortal(overlay, target);
    }

    return null;
};

OverlayHandle.propTypes = {
    // instance of a DOM element
    target: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

OverlayHandle.defaultProps = {
    className: '',
    style: {},
};

export default OverlayHandle;
